import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=587ce6ac&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=587ce6ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ce6ac",
  null
  
)

export default component.exports